module.exports = __webpack_public_path__ + "static/img/product2new.1307f62b.png";